
/* Swipers */

// intro
const bannerSwiper = new Swiper(".bannerSwiper", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });
const bannerSwiper2 = new Swiper(".bannerSwiper2", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".banner__swiper-button-next",
      prevEl: ".banner__swiper-button-prev",
    },
    pagination: {
        el: ".banner__swiper-pagination",
    },
    thumbs: {
      swiper: bannerSwiper,
    },
  });


const comfortSwiper = new Swiper(".comfortSwiper", {
    spaceBetween: 10,
    slidesPerView: 1.1,
    pagination: {
        el: ".comfort__swiper-pagination",
    },
    breakpoints: {
        1350: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
        950: {
            slidesPerView: 3.6,
            spaceBetween: 10,
        },
        580: {
            slidesPerView: 2.5,
            spaceBetween: 10,
        },
    },
  });

const includedSwipers = document.querySelectorAll('.includedSwiper');
    
includedSwipers.forEach((swiperElement, index) => {
    const nextButton = swiperElement.closest('.container').querySelector('.included__swiper-button-next');
    const prevButton = swiperElement.closest('.container').querySelector('.included__swiper-button-prev');
    const pagination = swiperElement.closest('.container').querySelector('.included__swiper-pagination');

    new Swiper(swiperElement, {
        spaceBetween: 8,
        slidesPerView: 1.1,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        pagination: {
            el: pagination,
        },
        breakpoints: {
            1460: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            1100: {
                slidesPerView: 3.2,
                spaceBetween: 10,
            },
            580: {
                slidesPerView: 2.2,
                spaceBetween: 10,
            },
        },
    });
});

  const roomsSwiper = new Swiper(".roomsSwiper", {
    spaceBetween: 8,
    slidesPerView: 1.1,
    pagination: {
        el: ".rooms__swiper-pagination",
    },
    breakpoints: {
        1480: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1120: {
            slidesPerView: 3.2,
            spaceBetween: 10,
        },
        620: {
            slidesPerView: 2.2,
            spaceBetween: 10,
        },
    },
  });


  const pansionatReviewSwiper = new Swiper(".pansionatReviewSwiper", {
    spaceBetween: 10,
    slidesPerView: 1,
    navigation: {
        nextEl: ".pansionat-review__swiper-button-next",
        prevEl: ".pansionat-review__swiper-button-prev",
    },
    pagination: {
        el: ".pansionat-review__swiper-pagination",
    },
    grabCursor: true,
    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: true,
        translate: ["-120%", 0, -500],
      },
      next: {
        shadow: true,
        translate: ["120%", 0, -500],
      },
    },
  });


  const introSwiper = new Swiper(".introSwiper", {
    //spaceBetween: 10,
    slidesPerView: 1,
    navigation: {
        nextEl: ".intro__swiper-button-next",
        prevEl: ".intro__swiper-button-prev",
    },
    pagination: {
        el: ".intro__swiper-pagination",
    },
    grabCursor: true,
    effect: "creative",
    creativeEffect: {
    prev: {
        shadow: true,
        translate: [0, 0, -400],
    },
    next: {
        translate: ["100%", 0, 0],
    },
    },
  });



const pansionatsSwiper = new Swiper(".pansionatsSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".pansionats__swiper-button-next",
        prevEl: ".pansionats__swiper-button-prev",
    },
    scrollbar: {
        el: ".pansionats__swiper-scrollbar",
    },
});
if (window.innerWidth < 700) {
    pansionatsSwiper.enable()
} else {
    pansionatsSwiper.disable()
}
window.addEventListener('resize', function() {
    if (window.innerWidth < 700) {
        pansionatsSwiper.enable()
    } else {
        pansionatsSwiper.disable()
    }
});

const pansionatsPageSwiper = new Swiper(".pansionatsPageSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".pansionats-page__swiper-button-next",
        prevEl: ".pansionats-page__swiper-button-prev",
    },
    pagination: {
        el: ".pansionats-page__swiper-pagination",
    },
    breakpoints: {
        1720: {
            slidesPerView: 4,
            spaceBetween: 10,
        },
        1181: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
        670: {
            slidesPerView: 2.2,
            spaceBetween: 10,
        },
    },
});

const doctorsSwiper = new Swiper(".doctorsSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 8,
    navigation: {
        nextEl: ".doctors__swiper-button-next",
        prevEl: ".doctors__swiper-button-prev",
    },
    pagination: {
        el: ".doctors__swiper-pagination",
    },
    breakpoints: {
        1520: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1181: {
            slidesPerView: 3.2,
            spaceBetween: 10,
        },
        630: {
            slidesPerView: 2.2,
            spaceBetween: 10,
        },
    },
});

const licenseSwiper = new Swiper(".licenseSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 8,
    navigation: {
        nextEl: ".license__swiper-button-next",
        prevEl: ".license__swiper-button-prev",
    },
    pagination: {
        el: ".license__swiper-pagination",
    },
    breakpoints: {
        1520: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1181: {
            slidesPerView: 3.2,
            spaceBetween: 10,
        },
        630: {
            slidesPerView: 2.2,
            spaceBetween: 10,
        },
    },
});

const reviewsSwiper = new Swiper(".reviewsSwiper", {
    spaceBetween: 8,
    slidesPerView: 1.1,
    navigation: {
        nextEl: ".reviews__swiper-button-next",
        prevEl: ".reviews__swiper-button-prev",
    },
    pagination: {
        el: ".reviews__swiper-pagination",
    },
    breakpoints: {
        1460: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1100: {
            slidesPerView: 3.2,
            spaceBetween: 10,
        },
        600: {
            slidesPerView: 2.2,
            spaceBetween: 10,
        },
    },
  });

  const reviewsYandexSwiper = new Swiper(".reviewsYandexSwiper", {
    spaceBetween: 10,
    slidesPerView: 1.1,
    navigation: {
        nextEl: ".reviews-yandex__swiper-button-next",
        prevEl: ".reviews-yandex__swiper-button-prev",
    },
    pagination: {
        el: ".reviews-yandex__swiper-pagination",
    },
    breakpoints: {
        1350: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
        950: {
            slidesPerView: 3.6,
            spaceBetween: 10,
        },
        580: {
            slidesPerView: 2.5,
            spaceBetween: 10,
        },
    },
  });


  const reviewsPageSwiper = new Swiper(".reviewsPageSwiper", {
    spaceBetween: 8,
    slidesPerView: 1.1,
    pagination: {
        el: ".reviews__swiper-pagination",
    },
  });
if (window.innerWidth < 700) {
    reviewsPageSwiper.enable()
} else {
    reviewsPageSwiper.disable()
}
window.addEventListener('resize', function() {
    if (window.innerWidth < 700) {
        reviewsPageSwiper.enable()
    } else {
        reviewsPageSwiper.disable()
    }
});

  const reviewsYandexPageSwiper = new Swiper(".reviewsYandexPageSwiper", {
    spaceBetween: 10,
    slidesPerView: 1.1,
    pagination: {
        el: ".reviews-yandex__swiper-pagination",
    },
  });

if (window.innerWidth < 700) {
    reviewsYandexPageSwiper.enable()
} else {
    reviewsYandexPageSwiper.disable()
}
window.addEventListener('resize', function() {
    if (window.innerWidth < 700) {
        reviewsYandexPageSwiper.enable()
    } else {
        reviewsYandexPageSwiper.disable()
    }
});


const articlesSwiper = new Swiper(".articlesSwiper", {
    spaceBetween: 8,
    slidesPerView: 1.1,
    navigation: {
        nextEl: ".articles__swiper-button-next",
        prevEl: ".articles__swiper-button-prev",
    },
    pagination: {
        el: ".articles__swiper-pagination",
    },
    breakpoints: {
        1460: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1100: {
            slidesPerView: 3.2,
            spaceBetween: 10,
        },
        640: {
            slidesPerView: 2.2,
            spaceBetween: 10,
        },
    },
  });


/* End swipers */